<template>
  <div class="app-container">
    <div class="loading-box" v-if="formLoading">
      <el-skeleton :rows="6" animated />
    </div>
    <el-form v-else :model="form" :rules="rules" label-width="80px">
      <el-form-item label="类型" prop="link_type">
        <el-select v-model="form.link_type">
          <el-option label="富文本" :value="0" />
          <el-option label="跳转公众号文章" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.link_type === 0" label="详细介绍" prop="description">
        <div style="max-width: 1312px;">
          <tinymce :height="512" v-model="form.description" :value="content" ref="tinymce" />
        </div>
      </el-form-item>
      <el-form-item v-else label="文章链接" prop="link_to">
        <el-input style="max-width: 315px;" v-model="form.link_to" type="textarea" :rows="3"
          placeholder="请输入内容"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import request from "@/utils/request";

export default {
  name: "TinymceDemo",
  components: { Tinymce },
  data: () => ({
    rules: {
      link_type: [
        { required: true, message: '请选择类型!', trigger: 'blur' }
      ],
      description: [
        { required: true, message: '请填写介绍内容!', trigger: 'blur' }
      ],
      link_to: [
        { required: true, message: '请输入文章链接!', trigger: 'blur' }
      ]
    },
    form: {
      id: 1,
      link_type: 1,
      link_to: "",
      description: "",
    },
    formLoading: false
  }),
  created() {
    this.getAbout();
  },
  methods: {
    getAbout() {
      this.formLoading = true
      request({
        url: "/api/backend/banners/about",
        method: "get",
      }).then(response => {
        this.content = response.data.description || response.data.link_to;
        this.form = response.data;
        this.formLoading = false
      });
    },
    handleClear() {
      this.content = "";
      this.$refs.tinymce.setContent("");
    },
    reset() {
      this.form = {
        link_type: null,
        link_to: "",
        description: "",
      }
    },
    onSubmit() {
      this.$confirm("将保存该修改, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          await request({
            url: "/api/backend/banners/about",
            method: "POST",
            data: this.form
          })
          this.getAbout()
          this.$message({
            message: '操作成功!',
            type: 'success'
          })
        } catch { this.$message.error('出错了!'); }
      })
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
